import { render, staticRenderFns } from "./faces.vue?vue&type=template&id=767cc64b&scoped=true&"
import script from "./faces.vue?vue&type=script&lang=js&"
export * from "./faces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cc64b",
  null
  
)

export default component.exports